import React from 'react';
import DsModal from '../../DsModal';
import '../../../../css/common/chat/ChatAnnouncements.css';

const formatAnnouncementTime = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleString('ja-JP', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

const ChatAnnouncementListModal = ({
  open = false,
  announcements = [],
  onClose = null,
  onRemove = null,
  removingMessageId = '',
  onSelect = null,
}) => {
  return (
    <DsModal open={open} onClose={onClose} title="アナウンス一覧" size="md">
      <div className="chat-announcement-modal__body">
        {Array.isArray(announcements) && announcements.length ? (
          announcements.map((announcement) => {
            const messageId = String(announcement?.messageId || '');
            const targetUrl = String(announcement?.targetUrl || '');
            const ticketSales = announcement?.messageFormat === 'ticket_sales_shared'
              ? announcement?.ticketSales
              : null;
            const isRemoving = removingMessageId && messageId === String(removingMessageId);
            return (
              <div key={messageId || announcement?.announcementId} className="chat-announcement-modal__row">
                <button
                  type="button"
                  className="chat-announcement-modal__rowButton"
                  onClick={() => {
                    if (typeof onSelect === 'function' && messageId) {
                      onSelect(messageId);
                    } else if (targetUrl && typeof window !== 'undefined') {
                      window.location.assign(targetUrl);
                    }
                  }}
                  disabled={!(typeof onSelect === 'function' && messageId) && !targetUrl}
                >
                  <div className="chat-announcement-modal__preview">
                    {announcement?.preview || 'アナウンス'}
                  </div>
                  <div className="chat-announcement-modal__meta">
                    {formatAnnouncementTime(announcement?.announcedAt)}
                  </div>
                  {ticketSales ? (
                    <dl className="chat-announcement-modal__ticket-sales" aria-label="券売状況の更新内容">
                      <div><dt>前日</dt><dd>{Number(ticketSales.previousDaySold || 0).toLocaleString('ja-JP')}枚</dd></div>
                      <div><dt>現在合計</dt><dd>{Number(ticketSales.sold || 0).toLocaleString('ja-JP')}枚</dd></div>
                      <div><dt>販売率</dt><dd>{ticketSales.progressPercent == null ? '—' : `${ticketSales.progressPercent}%`}</dd></div>
                    </dl>
                  ) : null}
                  {targetUrl ? <span className="chat-announcement-modal__detail-link">詳細を見る</span> : null}
                </button>
                {typeof onRemove === 'function' && messageId ? (
                  <button
                    type="button"
                    className="chat-announcement-modal__remove"
                    onClick={() => onRemove(messageId)}
                    disabled={Boolean(isRemoving)}
                  >
                    {isRemoving ? '解除中…' : '解除'}
                  </button>
                ) : null}
              </div>
            );
          })
        ) : (
          <div className="chat-announcement-modal__empty">アナウンスはありません。</div>
        )}
      </div>
    </DsModal>
  );
};

export default ChatAnnouncementListModal;
